// customToast.js
import { toast } from "react-toastify";

export type ToastOptions = {
  displayTime?: number;
};

const customToast = {
  success(msg: any, options?: ToastOptions) {
    return toast.success(msg, {
      className: "custom-toast custom-toast-success",
      autoClose: options?.displayTime ?? 3000,
      closeButton: true,
      position: "top-center",
      hideProgressBar: true,
    });
  },
  error(msg: any, options?: ToastOptions) {
    return toast.error(msg, {
      className: "custom-toast custom-toast-error",
      autoClose: options?.displayTime ?? 3000,
      closeButton: true,
      position: "top-center",
      hideProgressBar: true,
    });
  },
  info(msg: string, options?: ToastOptions) {
    return toast.info(msg, {
      className: "custom-toast custom-toast-info",
      autoClose: options?.displayTime ?? 3000,
      closeButton: false,
    });
  },
};

export default customToast;
